/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit City/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function City({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Address/NewAddress/Content/Fields/City",
  isInvalid,
  onChange
  
}) {
let newAddressCityValueData = fromData.useDataValue({ viewPath,
context: 'new_address',
path: 'city',
})
let newAddressCityIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_address',
path: 'city',
validate: fromValidate.textInput,
})
let newAddressCityChangeData = fromData.useDataChange({ viewPath,
context: 'new_address',
path: 'city',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="City.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 label="City"
 marginTop={dtSpaceM}
 data="new_address.city"
 validate="/Data/validate.js textInput"
 invalid={!newAddressCityIsValidData}
 value={newAddressCityValueData}
 onChange={newAddressCityChangeData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
)}
</TysiaInputWithLabelField>
</div>
{children}
</React.Fragment>)
}